.container {
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-small);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem;
  cursor: pointer;
  background-color: var(--color-surfaces-bg-elevation-3);
  gap: 0.8rem;

  &[data-dim='true'] {
    background-color: var(--color-surfaces-bg-elevation-2);

    & p {
      color: var(--color-texts-middle-contrast);
    }
  }
}

.title-container {
  display: flex;
  flex-direction: row;
  width: 0;
  flex: 1;
  align-items: center;
}

.title {
  font-weight: 600;
  line-height: 1.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-texts-high-contrast);
}
